import {
  GET_SHORTCUT_APPS_LIST,
  GET_SHORTCUT_APPS_LIST_SUCCESS,
  GET_SHORTCUT_APPS_LIST_ERROR,
  GET_SHORTCUT_APP_DATA,
  GET_SHORTCUT_APP_DATA_SUCCESS,
  GET_SHORTCUT_APP_DATA_ERROR,
  CREATE_SHORTCUT_APP_DATA,
  CREATE_SHORTCUT_APP_DATA_SUCCESS,
  CREATE_SHORTCUT_APP_DATA_ERROR,
  UPDATE_SHORTCUT_APP_DATA,
  UPDATE_SHORTCUT_APP_DATA_SUCCESS,
  UPDATE_SHORTCUT_APP_DATA_ERROR,
  DELETE_SHORTCUT_APP_DATA,
  DELETE_SHORTCUT_APP_DATA_SUCCESS,
  DELETE_SHORTCUT_APP_DATA_ERROR,
} from "./actionType";

// Action for getting shortcut apps list
export const getShortcutAppsList = () => ({
  type: GET_SHORTCUT_APPS_LIST,
});

export const getShortcutAppsListSuccess = (data) => ({
  type: GET_SHORTCUT_APPS_LIST_SUCCESS,
  payload: data,
});

export const getShortcutAppsListError = (error) => ({
  type: GET_SHORTCUT_APPS_LIST_ERROR,
});

// Action for getting shortcut app data
export const getShortcutAppData = (data) => ({
  type: GET_SHORTCUT_APP_DATA,
  payload: data,
});

export const getShortcutAppDataSuccess = (data) => ({
  type: GET_SHORTCUT_APP_DATA_SUCCESS,
  payload: data,
});

export const getShortcutAppDataError = (error) => ({
  type: GET_SHORTCUT_APP_DATA_ERROR,
  payload: error,
});

// Action for creating shortcut app data
export const createShortcutAppData = (data) => ({
  type: CREATE_SHORTCUT_APP_DATA,
  payload: data,
});

export const createShortcutAppDataSuccess = (data) => ({
  type: CREATE_SHORTCUT_APP_DATA_SUCCESS,
  payload: data,
});

export const createShortcutAppDataError = (error) => ({
  type: CREATE_SHORTCUT_APP_DATA_ERROR,
  payload: error,
});

// Action for updating shortcut app data
export const updateShortcutAppData = (data) => ({
  type: UPDATE_SHORTCUT_APP_DATA,
  payload: data,
});

export const updateShortcutAppDataSuccess = (data) => ({
  type: UPDATE_SHORTCUT_APP_DATA_SUCCESS,
  payload: data,
});

export const updateShortcutAppDataError = (error) => ({
  type: UPDATE_SHORTCUT_APP_DATA_ERROR,
  payload: error,
});

// Action for deleting shortcut app data
export const deleteShortcutAppData = (data) => ({
  type: DELETE_SHORTCUT_APP_DATA,
  payload: data,
});

export const deleteShortcutAppDataSuccess = (data) => ({
  type: DELETE_SHORTCUT_APP_DATA_SUCCESS,
  payload: data,
});

export const deleteShortcutAppDataError = (error) => ({
  type: DELETE_SHORTCUT_APP_DATA_ERROR,
  payload: error,
});
